import { Attachment, IAttachment } from '@/models/Attachment'
import ModelBase, {IModelBase} from '@/models/ModelBase'
import { KeyPair } from '@/types/KeyPair'

export interface ITopicComment extends IModelBase {
  topic_id?: number
  content?: string
  status?: string
  status_text?: string
  created_user?: string
  updated_user?: string
  attachments?: Array<IAttachment>
}

export default class TopicComment extends ModelBase {
  topic_id?: number
  content? = ''
  status?: string
  status_text?: string
  created_user = ''
  updated_user = ''
  attachments?: Array<Attachment> = []

  constructor(defaults?: ITopicComment) {
    super(defaults)
    if (defaults) {
      this.topic_id = defaults.topic_id
      this.content = defaults.content
      this.status = defaults.status
      this.status_text = defaults.status_text
      this.created_user = defaults.created_user
      this.updated_user = defaults.updated_user
      this.attachments = defaults.attachments?.map(a => new Attachment(a))
    }
  }

  get statusColor(): string {
    switch (this.status) {
      case 'waiting': return '#DF867B'
      case 'in_progress': return '#5487C0'
      case 'done': return '#74B3A6'
      case 'completed': return '#B3BD53'
    }
  }

  toParams(): KeyPair {
    return {
      topic_id: this.topic_id,
      content: this.content,
      status: this.status,
      created_user: this.created_user,
      updated_user: this.updated_user
    }
  }
}
